<div class="json-viewer">
  <ng-container *ngIf="json !== undefined">
    <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: json, key: null, path: [] }"></ng-container>
  </ng-container>
</div>

<ng-template #renderNode let-node let-key="key" let-path="path">
  <div class="node-line">
    <span *ngIf="isExpandable(node)" (click)="toggle(path)" class="toggle-btn">
      {{ isExpanded(path) ? "▼" : "▶" }}
    </span>
    <span *ngIf="key !== null" class="key">{{ key }}:</span>
    <ng-container *ngIf="isExpandable(node)">
      <span *ngIf="!isExpanded(path)">
        {{ beArray(node) ? "[...]" : key === null ? collapsedLabel : "{...}" }}
      </span>
      <ng-container *ngIf="isExpanded(path)">
        <div class="nested">
          <ng-container *ngFor="let k of keys(node)">
            <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: node[k], key: k, path: path.concat([k]) }"></ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <span *ngIf="!isExpandable(node)" class="value">{{ node | json }}</span>
  </div>
</ng-template>
